import { teams } from "@/mocks/teams";
import SectionHeading from "@/components/feature/SectionHeading";
import TeamCard from "@/components/feature/TeamCard";

export default function FeaturedTeams() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <SectionHeading
        eyebrow="TEAMS"
        title="推荐球队"
        description="本赛季欧冠舞台上的热门球队，点击查看球队资料、阵容与近期战绩。"
        linkTo="/category/season"
        linkLabel="更多球队"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {teams.map((team) => (
          <TeamCard key={team.id} team={team} />
        ))}
      </div>
    </section>
  );
}